export default function formatPriceNumber(price: string): number {

	const priceNumber = price.replace('R$', '').replace(' ', '').replace('.', '').replace(',', '.');

	return Number(priceNumber);
}